<template>
  <q-list padding>
    <template v-if="!loading">
      <q-item>
        <q-item-section avatar>
          <avatar :project="project" />

        </q-item-section>

        <q-item-section>
          {{ project?.name }} ({{ project?.projectType?.name }})
        </q-item-section>
      </q-item>

      <q-item clickable v-ripple :to="`/projects/${projectId}/tasks`">
        <q-item-section avatar>
          <q-icon name="task" />
        </q-item-section>

        <q-item-section>
          Задачи
        </q-item-section>
      </q-item>

      <q-item clickable v-ripple :to="`/projects/${projectId}/users`" v-if="project?.yourPermission === 'ADMINISTRATOR'">
        <q-item-section avatar>
          <q-icon name="people" />
        </q-item-section>

        <q-item-section>
          Участники
        </q-item-section>
      </q-item>

      <q-expansion-item :to="`/projects/${projectId}/settings`" v-if="project?.yourPermission === 'ADMINISTRATOR'"
        icon="settings" label="Настройки">
        <q-expansion-item label="Типы задач" :header-inset-level="1" :content-inset-level="1.5">
          <q-list>
            <q-item v-for="taskType in taskTypes" clickable v-ripple :key="taskType.id"
              :to="`/projects/${projectId}/settings/taskType/${taskType.id}`"
              v-if="project?.yourPermission === 'ADMINISTRATOR'">
              <q-item-section>
                {{ taskType.name }}
              </q-item-section>
            </q-item>
            <q-item clickable v-ripple :to="`/projects/${projectId}/settings/taskType/new`"
              v-if="project?.yourPermission === 'ADMINISTRATOR'">
              <q-item-section avatar>
                <q-icon name="add" />
              </q-item-section>
              <q-item-section>
                Новый тип задач
              </q-item-section>
            </q-item>

          </q-list>
        </q-expansion-item>
        <q-item clickable v-ripple :to="`/projects/${projectId}/settings/templates`"
          v-if="project?.yourPermission === 'ADMINISTRATOR'">
          <q-item-section avatar>
            <q-icon name="description" />
          </q-item-section>
          <q-item-section>
            Шаблоны
          </q-item-section>
        </q-item>
      </q-expansion-item>
    </template>
    <template v-else>
      <q-item style="max-width: 300px">
        <q-item-section avatar>
          <q-skeleton type="QAvatar" />
        </q-item-section>

        <q-item-section>
          <q-item-label>
            <q-skeleton type="text" />
          </q-item-label>
          <q-item-label caption>
            <q-skeleton type="text" width="65%" />
          </q-item-label>
        </q-item-section>
      </q-item>

      <q-item style="max-width: 300px">
        <q-item-section>
          <q-item-label>
            <q-skeleton type="text" />
          </q-item-label>
          <q-item-label caption>
            <q-skeleton type="text" width="90%" />
          </q-item-label>
        </q-item-section>
      </q-item>

      <q-item style="max-width: 300px">
        <q-item-section>
          <q-item-label>
            <q-skeleton type="text" width="35%" />
          </q-item-label>
          <q-item-label caption>
            <q-skeleton type="text" />
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
  </q-list>
</template>

<script setup lang="ts">
import { useProjectStore } from "../../store/project";
import { storeToRefs } from "pinia";
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useTaskTypes } from "../../composables/task";
import Avatar from "../Avatar.vue";

const route = useRoute()

const projectId = computed(() => Number(route.params.projectId))

watch(projectId, val => {
  if (val) {
    store.select(val)
  }
})
const store = useProjectStore()

store.select(projectId.value)

const { project, loading } = storeToRefs(store)

const { data: taskTypes } = useTaskTypes(projectId)
</script>

<style scoped></style>